/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const investmentNeedBurnPhaseDtoSchema = z.object({
  label: z.optional(z.string()),
  value: z.optional(z.string()),
  description: z.optional(z.string()),
});
